import { render, staticRenderFns } from "./sidebar-value-group.vue?vue&type=template&id=91a5ac74&scoped=true&"
import script from "./sidebar-value-group.vue?vue&type=script&lang=js&"
export * from "./sidebar-value-group.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-value-group.vue?vue&type=style&index=0&id=91a5ac74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a5ac74",
  null
  
)

export default component.exports